import React from 'react'

import { theme } from '@hhgtech/hhg-components'

import type { IconProps } from './types'

const WarningCircle: React.FC<IconProps> = ({
  size = 24,
  color = theme.colors.yellow600,
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clip-path="url(#a)">
        <path
          d="M4 .444A3.56 3.56 0 0 0 .444 4 3.56 3.56 0 0 0 4 7.555 3.56 3.56 0 0 0 7.555 4 3.56 3.56 0 0 0 4 .444m-.333 1.97a.333.333 0 0 1 .666 0v1.808a.333.333 0 0 1-.666 0zM4 5.963a.445.445 0 1 1 0-.89.445.445 0 0 1 0 .89"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h8v8H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default WarningCircle
